// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Client-___clients__container___1GnfV","content":"src-components-Client-___clients__content___1ymjy","grid-container":"src-components-Client-___clients__grid-container___1nITT","nav-list":"src-components-Client-___clients__nav-list___3xbLv","item":"src-components-Client-___clients__item___hdr0h","sort":"src-components-Client-___clients__sort___2ad-x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/clients.css
// module id = 1060
// module chunks = 0